import React from 'react';
import { siteCodes, SiteCodeType } from 'js/sign-components/common/brand';
import { getWebflowUrl } from 'signer-app/utils/url-helpers';

export function useProductHomepageURL(siteCode: SiteCodeType) {
  return React.useMemo(() => {
    switch (siteCode) {
      case siteCodes.fax:
        return getWebflowUrl('products/dropbox-fax', siteCodes.sign);
      case siteCodes.sign:
      default:
        return getWebflowUrl('', siteCode);
    }
  }, [siteCode]);
}
